export default {
  births: [],
  selectedBirth: null,
  error: false,
  errorMessage: '',
  selectedDay: null
}